<template>
    <select v-model="selectedValue" @change="onChange" class="chat-input">
      <option disabled value="">선택해주세요</option>
      <option v-for="option in options" :key="option" :value="option">
        {{ option }}
      </option>
    </select>
  </template>
<script>
export default {
  name: 'SelectInput',
  props: ['value', 'options'],
  data() {
    return {
      selectedValue: this.value
    }
  },
  methods: {
    onChange() {
      this.$emit('input', this.selectedValue)
      this.$emit('select')
    }
  }
}
</script>
